angular.module("app").constant("tables", {
    'title':  {type:"text",  placeholder: "", requiredMessage: 'titleRequired', minlength: "3", minlengthMessage: 'minLengthError' },
    'name':   {type:"slug", placeholder: ""},
    'date':  {type:'empty'},
    'status': {type: "text"}
});
